import React from "react"
import dayjs from "util/dayjs-init.js";
import "dayjs/locale/ja";
import { CalendarIcon, ClockIcon, LocalizationProvider, MobileDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs"
import { useSelector } from "react-redux";
import { selectedTimezone } from "../../model/slice/timezoneSlice";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { TIMEZONE } from "../../constants/timezone";
import { useTranslation } from "react-i18next";

export const MUIDateTimePicker = ({isSEPVessel, date, setDateFunction, isStart, limitationDate, disabled = false}) => {
  const {i18n} = useTranslation();
  const isJa = i18n.language === 'ja';
  const timezone = useSelector(selectedTimezone);
  const isAlarmPage = useLocation().pathname.split('/')[1] === 'alarm';
  const isUTC = timezone === TIMEZONE.UTC;
  const maxDate = isStart ? dayjs(limitationDate) : dayjs();
  const minDate = () => {
    if(isStart){
      if(isAlarmPage) return;
      return dayjs().subtract(isSEPVessel ? 40 : 30, 'day')
    }else{
      return dayjs(limitationDate);
    }
  } 
  const updateDate = (e) => {
    setDateFunction(dayjs(e).startOf("minute"));
  }

  const CustomActionBar = ({onAccept, onCancel}) => {
    return (
      <Box sx={{gridColumn: 2, gridRow: 3, display: 'flex', justifyContent: 'end', position: 'relative', bottom: '12px', right: '12px'}}>
        <Button onClick={onCancel} sx={{backgroundColor: '', color: '#28B6C7'}}>Cancel</Button>
        <Button onClick={onAccept} sx={{backgroundColor: '#28B6C7', color: 'white'}}>OK</Button>
      </Box>
    )
  }

  CustomActionBar.propTypes = {
    onAccept: PropTypes.func,
    onCancel: PropTypes.func,
  };
  return(
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={isJa ? "ja" : "en"}>
      <MobileDateTimePicker 
        key={timezone}
        value={(!date || date == '') ? null : dayjs(date).startOf("minute")} 
        disabled={disabled}
        onAccept={updateDate}
        ampm={false} 
        timezone={isUTC ? TIMEZONE.UTC : "default"} 
        maxDateTime={maxDate}
        minDateTime={minDate()}
        slots={{actionBar: CustomActionBar}}
        sx={{
          '& input': {color: 'white', cursor: disabled ? 'not-allowed' : 'pointer', padding: '4px 8px'}, 
          '& input::selection' : {backgroundColor: 'transparent'},
          background: '#2f3a47', 
          width: '100%',
        }}
        slotProps={{
          mobilePaper: {sx : {background: '#2f3a47', color: 'white'}}, 
          leftArrowIcon: {sx: {color: 'white'}},
          rightArrowIcon: {sx: {color: 'white'}},
          tabs: {
            dateIcon: <CalendarIcon sx={{fill: "white"}} />,
            timeIcon: <ClockIcon sx={{fill: 'white'}} />,
            sx: {'.MuiTabs-indicator': {backgroundColor: '#28B6C7'}}
          },
          toolbar: {
            toolbarFormat: isJa ? 'MM月DD日' : 'MMM DD',
            sx: {'& span': {color: 'white'}, '& span.Mui-selected': {color: 'white'}}
          },
          mobileTransition: {
            sx: {'&.MuiDayCalendar-weekDayLabel': {color: 'white'}}
          },
          calendarHeader: {
            format: isJa ? "YYYY年 MM月" : 'YYYY/MM',
            sx:{'& span' : {color: 'white'}, '& svg': {fill: 'white'}, '&.MuiPickersCalendarHeader-root': {color: 'white'}, 'MuiPickersDay-root': {color: 'white'}}
          },
          day: {
            sx: {
              color: 'white', 
              '&.MuiPickersDay-today:not(.Mui-selected)': {border: '1px solid rgba(255, 255, 255, 0.6)'}, 
              '&.MuiPickersDay-root.Mui-selected': {backgroundColor: '#28B6C7'},
            },
          },
          layout: {
            sx: {
                  '& .MuiDayCalendar-weekDayLabel': {
                    color: 'white',
                  },
                  '& .MuiClockNumber-root': {
                    color: 'white'
                  },
                  '& .MuiClock-pin': {
                    backgroundColor: '#28B6C7'
                  },
                  '& .MuiClockPointer-root': {
                    backgroundColor: '#28B6C7'
                  },
                  '& .MuiClockPointer-thumb': {
                    backgroundColor: '#28B6C7',
                    border: '16px solid #28B6C7'
                  }
            }
          }
        }}
        />
    </LocalizationProvider>
  )
}
MUIDateTimePicker.propTypes = {
  isSEPVessel: PropTypes.bool,
  date: PropTypes.string,
  setDateFunction: PropTypes.func,
  isStart: PropTypes.bool,
  limitationDate: PropTypes.string,
  disabled: PropTypes.bool,
}